module.exports = __webpack_public_path__ + "img/eaglemask.488f21f2.png";